import { render, staticRenderFns } from "./Alojamento.vue?vue&type=template&id=1cff137b&scoped=true&"
import script from "./Alojamento.vue?vue&type=script&lang=js&"
export * from "./Alojamento.vue?vue&type=script&lang=js&"
import style0 from "./Alojamento.vue?vue&type=style&index=0&id=1cff137b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cff137b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
